import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
import LANG from '@/common/language'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    user: {
      t: '',
      k: '',
      lang: '',
    },
    hotel: {},
    siteid: '', 
    language: '',
    langList: ['ko', 'en'],
    translation: {},
    currLang:null
  },
  mutations: {
    insertUser(state, payload){
      state.user = {...payload};
    },
    insertLanguage(state, payload){
      state.language = payload
    },
    insertTranslation(state, payload) {
      const obj={};
      LANG[payload.lang].forEach(x => {
          obj[x.term] = x.definition
        })
      state.translation = {...obj};
    },

    insertHotel(state, payload){
      state.hotel = payload;
    },
    insertSiteId(state, payload){
      state.siteid = payload;
    },

  },
  actions: {
    setIsLoading({state}, payload){
      state.isLoading = payload
    },
    async userCheck({state, commit, dispatch}, payload){
      
        const code = navigator.language;
        const browser = code.split('-') && code.split('-')[0] ? code.split('-')[0]:'en';
        const userLang = state.langList.filter(x=>{return x===browser}).length===1 ? browser:'en';
    
        const useParams = {
          t: new URLSearchParams(document.location.search).get("t"),
          k: new URLSearchParams(document.location.search).get("k"),
          lang: userLang
        }
        commit('insertLanguage', userLang);
        commit('insertTranslation', {lang: userLang});
        
        if(useParams.k){
          
          commit('insertUser', useParams);  
          const hotel = await dispatch('postReview', {
            cmd: 'sc-util',
            // func: 'get-site-name-by-metakey',
            func: 'get-site-name-by-ota',
            key: useParams.k
          });
          commit('insertHotel', hotel && hotel.message ? hotel.message : {});
    
          const site = await dispatch('postReview', {
            cmd: 'sc-util',
            // func: 'get-siteid-by-metakey',
            func: 'get-siteid-by-ota',
            key: useParams.k
          });
          commit('insertSiteId', site.message && site.message.siteid ? site.message.siteid:'');
    
          return {
            siteid: site.message.siteid,
            k: useParams.k
          };
          
        }else{
          
          
        }



      
    }

  },
  getters:{
    getIsLoading:  state=>{
      return state.isLoading;
    },
    getUser: state=>{
      return {...state.user, hotel: state.hotel[state.user.lang], siteid: state.siteid};
    },

    getTranslation: state=>{
      return state.translation;
    },
  },
  modules: modules
})


